import {connect} from "react-redux";
import ParkingActivityList from "./list";
import {bindActionCreators} from "redux";
import {activityList} from "../../../../service/Activity/action";
import {addTaggedAlong} from "../../../../service/Dealer/action";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
import {isCheckout} from "../../../../service/CarService/action";
import {markAttendance} from "../../../../service/Parking/action";
import {ratingSave} from "../../../../service/Dealer/action";
import {errorLogs} from "../../../../service/FasttagToll/action";

const mapStateToProps = (state) => ({
    activityListDetails: state.Activity.activityList,
    addedTaggedAlong: state.Dealer.addedTaggedAlong,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    isCheckoutDetails:state.CarService.isCheckout,
    attendance:state.Parking.attendance,
    savedRating: state.Dealer.savedRating,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            activityList,
            addTaggedAlong,
            documentUploadUrlPublic,
            isCheckout,
            markAttendance,
            ratingSave,
            errorLogs
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ParkingActivityList);
